import { loading } from './loading/loading.actions';
import * as ContentService from '../services/ContentService';
import { loadInfo } from './info/info.actions';
import { loginSuccess } from './user/user.actions';
import { notificationStart } from '../services/NotificationService';
import { startSocketIO } from '../services/SocketIOService';
import { startPushNotificationService } from '../services/PushNotificationService';

export function start() {
  return dispatch => {
    dispatch(loading(false));
    ContentService.getInfo().then(result => {
      if (result.success && result.data) {
        dispatch(loadInfo(result.data));
        if (result.data.member && result.data.member.id) {
          dispatch(loginSuccess(result.data.member));
          notificationStart();
          startPushNotificationService();
          if(localStorage.EFRS_AUTH_TOKEN)
            startSocketIO(localStorage.EFRS_AUTH_TOKEN);
        } else localStorage.clear();
        setTimeout(() => dispatch(loading(false)), 200);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/startThunk.js